import { Fragment } from 'react';

import { Typography } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import { useSidebar } from '@src/context/hooks';

function SidebarItem(props) {
  const { label, icon, component, slotProps, ...restProps } = props;
  const { listItem: listItemProps = {}, listItemButton: listItemButtonProps = {} } = slotProps || {};

  const { isCollapsed } = useSidebar();

  const Wrapper = isCollapsed
    ? { Component: Tooltip, props: { arrow: true, placement: 'right', title: label } }
    : { Component: Fragment, props: {} };


  return (
    <Wrapper.Component {...Wrapper.props}>
      <ListItem disablePadding sx={[StyleSheet.listItem, listItemProps.sx]}>
        <ListItemButton
          sx={[StyleSheet.listItemButton, listItemButtonProps.sx]}
          component={component}
          {...restProps}
        >
          <ListItemIcon sx={StyleSheet.listItemIcon}>{icon}</ListItemIcon>

          {!isCollapsed
            ? (
              <ListItemText
                primary={
                  <Typography
                    variant="h5"
                    sx={StyleSheet.listItemText}
                    color="inherit"
                  >
                    {label}
                  </Typography>
                }
              />
            )
            : null}
        </ListItemButton>
      </ListItem>
    </Wrapper.Component >

  );
}

const StyleSheet = {
  listItem: {},
  listItemButton: {
    height: '48px', boxSizing: 'border-box',
    zIndex: 1201,
    mb: 0.5,
  },
  listItemIcon: (theme) => ({
    minWidth: '24px',
    mr: 2,
    stroke: theme.palette.common.white,
    '& .MuiSvgIcon-root': {
      height: '20px',
      width: '20px',
    },
  }),
  listItemText: (theme) => ({
    color: theme.palette.grey[300],
  }),

};


SidebarItem.displayName = 'SidebarItem';
export default SidebarItem;
